<template>
  <div ref="banenrRef" class="banner">
    <q-carousel
      v-model="slide"
      transition-prev="slide-right"
      transition-next="slide-left"
      swipeable
      animated
      infinite
      :navigation="list.length > 1"
      height="auto"
      class="banner-core rounded-borders"
      :autoplay="3000"
    >
      <q-carousel-slide
        v-for="(item, index) in list"
        :key="item.id"
        class="column no-wrap flex-center slide-item"
        :name="index"
      >
        <a class="img block full-height full-width" @click="jump(item)">
          <q-img contain :src="$ossLimit(item.imgSrc, 800)" :ratio="ratio" />
        </a>
      </q-carousel-slide>
    </q-carousel>

    <div v-show="showDialog" class="flex-center image-container">
      <div class="mask" @click="onClickImgDialog" />
      <q-img class="image-item" contain :src="imgUrl" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    ratio: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      slide: 0,
      showDialog: false,
      imgUrl: ''
    };
  },
  methods: {
    jump(item) {
      if (item.link?.trim()) {
        window.open(item.link, '_blank');
      } else if (item.dialog) {
        this.showDialog = true;
        this.imgUrl = item.imgSrc
      }
    },
    onClickImgDialog() {
      this.showDialog = false;
      this.imgUrl = '';
    }
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background: #ffffff;
  padding: 8px 12px;
  &-core {
    border-radius: 8px;
    overflow: hidden;
    // @safari: 在safari中transform中的子元素层级会被提高，导致给子元素设置的圆角失效，在这里同样给父元素设置transform提高层级已达到目的
    transform: scale(1);
    .slide-item {
      position: relative;
      border-radius: 8px;
      overflow: hidden;
    }
  }
  :deep(.q-carousel__slide) {
    padding: 0;
    overflow: hidden;
  }
  :deep(.q-spinner) {
    color: $dark;
  }
  :deep(.q-carousel__control) {
    bottom: 0;
    .q-carousel__navigation-icon {
      margin: 0;
      font-size: 6px !important;
      .q-btn__wrapper {
        padding: 4px;
      }
    }
    .q-carousel__navigation-icon--active {
      color: $primary;
      font-size: 6px !important;
    }
  }
}
.image-container {
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 11;
  }
  .image-item {
    position: fixed;
    width: calc(100% - 48px);
    z-index: 12;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
